import React from 'react';
import { Form as ReactFinalForm } from 'react-final-form';

import * as hooks from './hooks';
import * as Types from './types';

export const Form = <FormValues, >({
    onSubmit,
    validate,
    formatData,
    validationConfig,
    fieldsToReplaceComma,
    skipValidationFields, // disabled or readOnly fields should be passed here to avoid its validation on submit
    validateOnBlur = true,
    ...props
}: Types.IExtendedFormProps<FormValues>): React.ReactElement => {
    const validateWrapped = hooks.useValidateWrapped({ validate, validationConfig, skipValidationFields });
    const onSubmitWrapped = hooks.useOnSubmitWrapped({ onSubmit, formatData, fieldsToReplaceComma });

    return (
        <ReactFinalForm<FormValues>
            onSubmit={onSubmitWrapped}
            validate={validateWrapped}
            validateOnBlur={validateOnBlur}
            {...props}
        />
    );
};

export default Form;
